"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidators = void 0;
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const fp_1 = require("lodash/fp");
const live_env_1 = require("@ledgerhq/live-env");
const MAX_VALIDATORS_NB = 1000; // Max number of validators to fetch
const URLS = {
    validatorList: (cluster) => {
        const clusterSlug = cluster === "mainnet-beta" ? "mainnet" : cluster;
        const baseUrl = (0, live_env_1.getEnv)("SOLANA_VALIDATORS_APP_BASE_URL");
        return `${baseUrl}/${clusterSlug}.json?order=score&limit=${MAX_VALIDATORS_NB}`;
    },
};
function getValidators(cluster) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = {
            method: "GET",
            url: URLS.validatorList(cluster),
        };
        const response = yield (0, network_1.default)(config);
        const allRawValidators = response.status === 200 ? response.data : [];
        // validators app data is not clean: random properties can randomly contain
        // data, null, undefined
        const tryFromRawValidator = (v) => {
            var _a, _b, _c;
            if (typeof v.active_stake === "number" &&
                typeof v.commission === "number" &&
                typeof v.total_score === "number" &&
                typeof v.vote_account === "string" &&
                v.delinquent !== true) {
                return {
                    activeStake: v.active_stake,
                    commission: v.commission,
                    totalScore: v.total_score,
                    voteAccount: v.vote_account,
                    name: (_a = v.name) !== null && _a !== void 0 ? _a : undefined,
                    avatarUrl: (_b = v.avatar_url) !== null && _b !== void 0 ? _b : undefined,
                    wwwUrl: (_c = v.www_url) !== null && _c !== void 0 ? _c : undefined,
                };
            }
            return undefined;
        };
        // FIXME Ordering of validators must be always the same, for this test to be stable:
        // https://github.com/LedgerHQ/ledger-live-common/blob/develop/src/__tests__/test-helpers/bridge.ts#L171-L188
        return (0, fp_1.compact)(allRawValidators.map(tryFromRawValidator));
    });
}
exports.getValidators = getValidators;
//# sourceMappingURL=index.js.map